module.exports = __webpack_public_path__ + "img/ce7086f.svg";